/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/mfa/reset`,
    // @ts-ignore for sm-axios
    urlTemplate: '/mfa/reset',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Resets the MFA registration. This operation verifies the one-time password (OTP), removes existing MFA registrations and removes all user device tokens recorded related to the given account.
 * 
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * browser session JWT to identify the current user
     */
    token: string
    userDeviceToken: string
    challengeId?: string
    /**
     * value could be otp or recovery code but recovery code is not supported at the moment
     */
    type: 'otp'
    code: string
  }
}

export interface Response {
  /**
   * is otp valid
   */
  valid: boolean
  /**
   * the number of requests remaining
   */
  rateLimitRemaining?: number
  /**
   * unix timestamp (seconds) of when verification can be attempted again. Only populated when rateLimitRemaining is 0.
   */
  nextAllowedTimestamp?: number
}

